import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const fetchHomepageLayout = createAsyncThunk(
  "homepageLayout/fetch",
  async (clientTitle) => {
    const response = await fetch(
      `/customConfig/${encodeURIComponent(clientTitle)}/homepage-layout.json`,
      { cache: "no-store" }
    );

    if (!response.ok) {
      throw new Error(`Layout request failed with ${response.status}`);
    }

    const layout = await response.json();
    if (!Array.isArray(layout) || layout.length === 0) {
      throw new Error("Homepage layout must be a non-empty array");
    }

    return layout;
  },
  {
    condition: (clientTitle, { getState }) => {
      if (!clientTitle) return false;
      const state = getState().homepageLayoutReducer;
      return !(
        state?.clientTitle === clientTitle &&
        ["loading", "succeeded"].includes(state?.status)
      );
    },
  }
);

const homepageLayoutSlice = createSlice({
  name: "homepageLayout",
  initialState: {
    clientTitle: null,
    layout: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHomepageLayout.pending, (state, action) => {
        state.clientTitle = action.meta.arg;
        state.layout = null;
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchHomepageLayout.fulfilled, (state, action) => {
        state.layout = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchHomepageLayout.rejected, (state, action) => {
        if (action.meta.condition) return;
        state.layout = null;
        state.status = "failed";
        state.error = action.error?.message || "Homepage layout unavailable";
      });
  },
});

export default homepageLayoutSlice.reducer;
